const About = () => {
  return (
    <section className="jumbotron row add_zindex">
      <div id="About" className="first1"></div>
      <div className="code-icon col-lg-4" data-aos="fade-down">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="col-lg-8 col-md-12 about__contant">
        <div id="about-me" data-aos="fade-down" data-aos-delay="200">
          <h2>About Me</h2>
          <p>
            Hi! I am a friendly and enthusiastic person who loves keeping up
            with the latest tech trends. I enjoy connecting with a diverse range
            of people to expand my knowledge and learn from their unique
            experiences. My expertise lies in web and app development, and I am
            excited about the opportunity to contribute to your company's
            success.
          </p>
        </div>
        <div id="address" data-aos="fade-down" data-aos-delay="400">
          <h2>Contact Details</h2>
          <p>
            Chitraarasu.k
            <br />
            51 Sri Sakthi Nagar, Gandhi Nagar(post)
            <br />
            Cuddalore, TamilNadu
            <br />
            kchitraarasu@gmail.com
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
